import React, { useState } from 'react';
import PropTypes from 'prop-types';
import APModal from 'components/Modal/APModal';

const SiteError = ({ uuid, message, removeSiteError, title='Something went wrong.' }) => {

  const [isOpen, setIsOpen] = useState(true);

  const errorCloseHandler = () => {
    setIsOpen(false);
    removeSiteError(uuid);
  };

  const actions = (
    <section className="modal_confirm__buttons">
      <button
        onClick={errorCloseHandler}
        className="button"
      >
        Got it
      </button>
    </section>
  );

  return (
    <APModal
      open={isOpen}
      onClose={errorCloseHandler}
      name="modal_confirm__container"
      title={title}
      actions={actions}
    >
      <section className="modal_confirm__content">
        <p className="submessage">
          {message}
        </p>
      </section>
    </APModal>
  );
};

SiteError.propTypes = {
  uuid: PropTypes.string,
  message: PropTypes.string,
  removeSiteError: PropTypes.func,
  title: PropTypes.string,
};

SiteError.defaultProps = {
  title: 'Something went wrong.',
};

export default SiteError;
